<template>
	<v-col class="pa-0" cols="12">
		<v-card class="mb-2 background-2 round-card">
			<v-card-title class="pa-3">
				<p class="pl-2 pl-xl-3">Mail automatiche</p>
				<v-spacer></v-spacer>
			</v-card-title>				
			<v-divider></v-divider>
			<v-list three-line subheader class="background-2 pa-2">
				<v-list-item>
					<v-list-item-action>
						<v-checkbox color="primary" v-model="settings['enable_mail_scheduling']"></v-checkbox>
					</v-list-item-action>
					<v-list-item-content>
						<v-list-item-title>Mail automatiche</v-list-item-title>
						<v-list-item-subtitle>Attiva l'invio automatico di email per i preventivi in stato 'Preventivo Inviato'
						</v-list-item-subtitle>
					</v-list-item-content>
				</v-list-item>
			</v-list>
			<v-divider></v-divider>
			<v-card-actions>
				<v-spacer></v-spacer>
				<v-btn text class="pa-2 mx-2" color="primary" @click.native="saveSettings">Salva</v-btn>
			</v-card-actions>
		</v-card>
	</v-col>
</template>
<script>
	import SettingsOptionsMixin from '@/mixins/SettingsOptionsMixin';

	export default {
		name:'quotations-scheduling-options',
		mixins: [SettingsOptionsMixin],
		data() {
			return {
				snackbar: false,
				model: 'quotation',
				settings: {
				    'enable_mail_scheduling': false,
				},
			}
		},
	}
</script>
